<div class="ai-map-container">
  <div class="map-header">
    <div class="flex align-items-center gap-2">
      <app-back-button
        [title]="'GIS' | translate"
        [parentRoute]="'/fields-identification'"></app-back-button>
    </div>

    <div class="header-controls">
      <div
        class="stats"
        *ngIf="!isLoading">
        <span style="margin-right: 15px">
          {{ "Detected Fields" | translate }}:
          <strong>{{ aiBoundariesCount }}</strong>
        </span>
        <span style="margin-right: 15px">
          {{ "Existing Fields" | translate }}:
          <strong>{{ existingFieldsCount }}</strong>
        </span>
        <span>
          {{ "STOP_LIST" | translate }}:
          <strong>{{ stopListCount }}</strong>
        </span>
      </div>
      <div
        *ngIf="isLoading"
        class="loading-badge">
        {{ "Loading..." | translate }}
      </div>
    </div>
  </div>

  <div class="content-wrapper">
    <div class="map-area">
      <app-openstreetmap
        #mainMap
        [mapOptions]="osmMapOptions"
        [mapController$]="osmMapController"
        (drawingCompleted)="onPolygonCreated($event)"></app-openstreetmap>
    </div>

    <div class="sidebar">
      <div class="filter-section">
        <label>{{ "Region Filter" | translate }}</label>
        <p-treeSelect
          [(ngModel)]="selectedRegion"
          [options]="regionNodes"
          placeholder="{{ 'Select Region' | translate }}"
          [filter]="true"
          [showClear]="true"
          appendTo="body"
          containerStyleClass="w-full"></p-treeSelect>

        <div style="margin-top: 8px">
          <msf-form-builder
            [fields]="dateFilterFields"
            [(model)]="dateFilterModel"
            (modelChange)="onDateFilterModelChange()"></msf-form-builder>
        </div>

        <button
          pButton
          type="button"
          label="{{ 'Apply' | translate }}"
          class="p-button-primary w-full mt-2"
          style="width: 100%; margin-top: 8px"
          [disabled]="!canApplyFilters"
          (click)="onApplyRegion()"></button>
      </div>

      <div class="filter-section">
        <label>{{ "MAP_SETTINGS" | translate }}</label>

        <div class="color-control-group">
          <div class="color-item">
            <div class="layer-toggle">
              <input
                type="checkbox"
                id="cbAiFields"
                [(ngModel)]="showAiFields"
                (change)="onLayerChange()" />
              <label
                for="cbAiFields"
                class="color-label">
                {{ "Detected Fields" | translate }}
              </label>
            </div>
            <input
              type="color"
              [(ngModel)]="aiColor"
              (change)="onLayerChange()"
              class="color-input" />
          </div>

          <div class="color-item">
            <div class="layer-toggle">
              <input
                type="checkbox"
                id="cbExistingFields"
                [(ngModel)]="showExistingFields"
                (change)="onLayerChange()" />
              <label
                for="cbExistingFields"
                class="color-label">
                {{ "Existing Fields" | translate }}
              </label>
            </div>
            <input
              type="color"
              [(ngModel)]="existingColor"
              (change)="onLayerChange()"
              class="color-input" />
          </div>

          <div class="color-item">
            <div class="layer-toggle">
              <input
                type="checkbox"
                id="cbStopList"
                [(ngModel)]="showStopList"
                (change)="onLayerChange()" />
              <label
                for="cbStopList"
                class="color-label">
                {{ "STOP_LIST" | translate }}
              </label>
            </div>
            <input
              type="color"
              [(ngModel)]="stopListColor"
              (change)="onLayerChange()"
              class="color-input" />
          </div>
        </div>
      </div>

      <div class="filter-section">
        <label>{{ "FIELD_GEOMETRY" | translate }}</label>

        <div
          *ngIf="!tempPolygonCoordinates"
          class="info-box">
          <i class="pi pi-info-circle"></i>
          <span>{{ "USE_MAP_TOOLS_INFO" | translate }}</span>
        </div>

        <div
          *ngIf="tempPolygonCoordinates"
          class="success-box">
          <i class="pi pi-check-circle"></i>
          <span>{{ "POLYGON_CREATED_SUCCESS" | translate }}</span>
        </div>

        <button
          pButton
          type="button"
          label="{{ 'SAVE_POLYGON' | translate }}"
          class="p-button-primary w-full"
          style="width: 100%"
          [disabled]="!tempPolygonCoordinates"
          (click)="onConfirmPolygon()"></button>

        <button
          *ngIf="tempPolygonCoordinates"
          pButton
          type="button"
          label="{{ 'RESET' | translate }}"
          class="p-button-outlined p-button-secondary w-full"
          style="width: 100%; margin-top: 8px"
          (click)="onResetPolygon()"></button>
      </div>
    </div>
  </div>
</div>

<app-field-boundary-modal
  [(visible)]="displayModal"
  [fieldData]="selectedAiField"
  (actionCompleted)="onActionCompleted()"></app-field-boundary-modal>
